import { render } from "./CommentModal.vue?vue&type=template&id=20454684&scoped=true"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"

import "./CommentModal.vue?vue&type=style&index=0&id=20454684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20454684"],['__file',"src/components/CommentModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20454684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20454684', __exports__)) {
    api.reload('20454684', __exports__)
  }
  
  module.hot.accept("./CommentModal.vue?vue&type=template&id=20454684&scoped=true", () => {
    api.rerender('20454684', render)
  })

}


export default __exports__